import styled from 'styled-components';
import em from 'polished/lib/helpers/em';
import React, { ReactNode } from 'react';

export const ScheduleWrapper = styled.div`
  margin-bottom: 8em;
`;

export const DayWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 3em;
  // padding: 0 3em;
  
  &::after {
    content: '';
    width: 25%;
  }
`;

export const EventsWrapper = styled.div`
  width: 25%;
  padding: 0 2em;
  box-sizing: border-box;
  margin: 4em 0 2em 0;
  
  @media (max-width: 1300px) {
    width: 33.3333333333%;
  }
  
   @media (max-width: 1000px) {
    width: 50%;
   }
   
   @media (max-width: 700px) {
    width: 100%;
   }
`;

export const Title = styled.span`
  display: block;
  font-size: 1.8em;
  line-height: 1.4;
  font-family: Flow-Poster-Bold;
  text-transform: uppercase;
`;

export const VenueTitle = Title.extend`
  color: ${props => props.theme.highlightColor};
  margin-bottom: ${em(1, 1.8)};
  padding-left: ${em(1, 1.8)};
`;

export const ArtistTitle = styled.a`
  display: block;
  font-size: 1.8em;
  line-height: 1.4;
  font-family: Flow-Poster-Bold, sans-serif;
  text-transform: uppercase;
  
  &:${props => props.theme.hoverProperty} {
    text-decoration: underline;
  }
`;


export const DayTitleWrapper = styled.div`
  margin-right: 4em;
  margin-top: 4em;
  padding-left: 3em;
`;

export const DayTitle = styled.span`
  display: block;
  font-size: 10em;
  font-family: Flow-Inverted;
  text-transform: uppercase;
  white-space: nowrap;
  
  @media (max-width: 1920px) {
    font-size: ${100 / (1920 * 0.01)}vw;
  }
  
  @media (max-width: 900px) {
    font-size: 4.6em;
  }
`;

export const ArtistEventTime = styled.span`
  font-size: 1.4em;
  padding-right: ${em(1, 1.4)};
  line-height: 1.68;
  //font-family: Flow-Poster-Bold;
  // color: ${props => props.theme.highlightColor};
  transition: color 0.2s ease-out;
`;

export const ArtistActionButton = styled.span`
  cursor: pointer;
  width: 3em;
  height: 3em;
  position: relative;
  
  &::after {
    content: '+';
    position: absolute;
    font-size: 2.2em;
    line-height: 1;
    font-family: Flow-Poster-Bold, sans-serif;
    //transform: ${props => props.theme.isTouch ? `scale(1)` : `scale(0)`};
    transition: transform 0.3s ease-out;
    left: 50%;
    top: 50%;
    margin-left: -6px;
    margin-top: -10px;
  }
  
  &:${props => props.theme.hoverProperty} {
    background-color: ${props => props.theme.highlightColor};
    
    &::after {
      transform: scale(1);
    }
  }
  
  &.remove {
    &::after {
      content: '-';
      transform: scale(1);
    }
  }
`;

export const Artist = styled.li`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: 0.5em 0.5em 0.5em 1em;
  justify-content: space-between;
  
  &:${props => props.theme.hoverProperty} {
    //background-color: ${props => props.theme.highlightColor};
    
     ${ArtistActionButton} {
       &::after {
        transform: scale(1);
      }
     }
  }
  
  &.item-active {
    background-color: ${props => props.theme.highlightColor};
    
    ${ArtistEventTime} {
      color: black;
    }

    //&::after {
    //  content: '-';
    //}
  }
`;

export const ArtistContent = styled.span`
  display: flex;
`;

export const ArtistVenue = styled.span`
  display: block;
  font-size: .75em;
  margin-top: .2em;
`;

export const MyFlowMenuArrow = styled.span`
  font-family: Flow-Poster-Bold;
  font-size: 3em;
  transform: rotate(-90deg);
  transition: transform 0.4s ease-out;
`;

export const MyFlowContentHeader = styled.header`
  display: flex;
  height: inherit;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0 3em;
  box-sizing: border-box;
`;

export const MyFlowTitle = styled.h2`
  font-size: 2.1em;
  font-family: Flow-Poster-Bold, sans-serif;
`;

export const MyFlowContent = styled.div`
  height: calc(100vh - 8em);
  overflow-y: scroll;
  width: 100%;
  background-color: ${props => props.theme.highlightColor};
  padding: 0 3em 5em;
  box-sizing: border-box;
`;

export const MyFlowScheduleListsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  
  &::after {
    content: '';
    width: 31%;
  }
`;

export const MyFlowScheduleDayList = styled.div`
  width: 31%;
  
  .day-title {
    font-size: 2.1em;
    font-family: Flow-Poster-Bold, sans-serif;
    white-space: nowrap;
    padding: 0 ${em(1, 2.1)};
    margin: ${em(5, 2.1)} 0;
  }
  
  ${ArtistEventTime} {
    color: black;
  }
  
  // ${Artist} {
  //   &::after {
  //     content: '-';
  //   }
  //  
  ${ArtistActionButton} {
    &:${props => props.theme.hoverProperty} {
        background-color: black;
        color: ${props => props.theme.highlightColor};
      }
    }
  }
  
  @media (max-width: 1000px) {
    width: 48%;
   }
   
   @media (max-width: 700px) {
    width: 100%;
   }
`;

export const MyFlowScheduleActionBar = styled.div`
  text-align: right;
`;

export const PrintButton = styled.a`
  cursor: pointer;
  font-size: 2.1em;
  font-family: Flow-Poster-Bold;
  padding: ${em(1, 2.1)} 0;
  display: inline-block;
  text-decoration: underline;
`;

export const MyFlowWrapper = styled.div`
  position: fixed;
  box-sizing: border-box;
  left: 0;
  right: 0;
  top: 0;
  height: 9em;
  width: 100%;
  background-color: ${props => props.theme.highlightColor};
  z-index: 1001;
  max-width: ${props => props.theme.containerMaxW/10}em;
  margin: auto;
  transform: translateY(calc(100vh - 9em));
  transition: transform 0.3s ease-out; 
  
  ${MyFlowScheduleActionBar}, ${MyFlowScheduleListsWrapper} {
    opacity: 0;
  }
  
  &.is-open {
    transform: translateY(0);
    
    ${MyFlowMenuArrow} {
      transform: rotate(90deg);
    }
    
    ${MyFlowScheduleActionBar}, ${MyFlowScheduleListsWrapper} {
      opacity: 1;
    } 
  }
`;

export const LoginOptionsList = styled.div`
  justify-content: center;
  flex-direction: row;
  display: flex;
`;

export const LoginOptionItem = styled.div`
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 1.5em;
    padding-right: 1.5em;
    text-decoration: none;
    color: black;
    
    span {
      display: block;
      width: 48px;
      height: 48px;
      margin-bottom: 7px;
      
      &.facebook {
        background-image: url(${props => props.theme.isRetina ? '/assets/images/facebook-sign-in@2x.png' : '/assets/images/facebook-sign-in.png'});
        background-size: contain;
      }
      
      &.google {
        background-image: url(${props => props.theme.isRetina ? '/assets/images/google-sign-in@2x.png' : '/assets/images/google-sign-in.png'});
        background-size: contain;
      }
    }
  }
`;

const FacebookButtonWrapper = styled.span`
  font-family: Flow-Poster-Bold, sans-serif;
  display: inline-flex;
  padding: .6em 1em;
  background-color: #415a93;
  color: white;
  font-size: 1.6em;
  align-items: center;
  cursor: pointer;
  
  &:hover {
    background-color: #506fb5;
  }
`;

const FBIcon = styled.span`
  font-feature-settings: "liga","dlig";
  color: inherit;
  font-size: 2em;
  vertical-align: middle;
  margin-right: ${1 / 2.0}em; 
`;

interface FacebookButtonProps {
  onClick: () => any;
  children?: ReactNode;
}

export const FacebookButton = (props: FacebookButtonProps) => {
  return (
    <FacebookButtonWrapper onClick={props.onClick}>
      <FBIcon>
        [FACEBOOK]
      </FBIcon>
      {props.children}
    </FacebookButtonWrapper>
  );
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/schedule/ui/index.tsx